// Must match the column order expected by pom-questionnaires `actions/bulk-upload`.
// A trailing '*' marks a mandatory column and is ignored by the backend when matching headers.
// `format` is only shown in the upload dialog, never written to the template header.
export const PLANT_ACTIONS_BULK_UPLOAD_COLUMNS = [
  {name: 'Plant name', isMandatory: true},
  {name: 'Title', isMandatory: true},
  {name: 'Source', isMandatory: true},
  {name: 'Cost leadership', isMandatory: true, format: 'TRUE/FALSE'},
  {name: 'Element', isMandatory: false},
  {name: 'Target costs', isMandatory: false},
  {name: 'Actual costs YTD', isMandatory: false},
  {name: 'Target KPI', isMandatory: false},
  {name: 'Actual KPI YTD', isMandatory: false},
  {name: 'Description', isMandatory: true},
  {name: 'Approvers', isMandatory: false},
  {name: 'Assignee', isMandatory: false},
  {name: 'Due Date', isMandatory: true}
] as const

export const PLANT_ACTIONS_BULK_UPLOAD_DELIMITER: string = ';'
export const PLANT_ACTIONS_BULK_UPLOAD_TEMPLATE_FILE_NAME: string =
  'plant-actions-upload-template.csv'
export const PLANT_ACTIONS_BULK_UPLOAD_ACCEPTED_EXTENSION: string = '.csv'
